// printibly code bkp

let theme_status = $("#current__theme").val();
let min__quantity = $("#min__quantity").val();
let currentQuantity = min__quantity;
let elemEnt = document.querySelector(".product__title");

document.addEventListener("DOMContentLoaded", function () {
  
    const wrapper = document.getElementById("t-modification");
    if (wrapper != undefined) {
        const canvasId = ["front", "backside"];

        const tshirtBox = wrapper.querySelector(".tshirt-div");
        const tshirtCanvasBox = wrapper.querySelectorAll(".canvasBox"),
            tshirtColorsBox = wrapper.querySelectorAll("[name='colorValues']"),
            tshirtSave = wrapper.querySelector(".save"),
            tshirtUploadBoxSelect = wrapper.querySelectorAll(".tshirt-toggle_button"),
            tshirtUploadBox = wrapper.querySelectorAll(".image_upload"),
            allFabricBox = wrapper.querySelectorAll(".tshirt-panel"),
            thumbImages = document.querySelectorAll(".tshirt-thumb-wrap > div"),
            tshirtUploaders = document.querySelectorAll(".tshirt-upload_box");
            
      
        // create canvas
        tshirtCanvasBox.forEach((e, i) => {
            tshirtUploadBox[i].setAttribute("data-id", canvasId[i]);
            allFabricBox[i].setAttribute("id", canvasId[i] + "-panel");
        });

        allFabricBox[0].classList.add("active");

        function frontBackFabricDraw(activePanel, imgObj, index) {
            // console.log(activePanel, imgObj, index);
            const tshirtDrawBox = activePanel.querySelector(".drawingArea"),
                tshirtPanelBox = activePanel.querySelector('.panel'),
                CanvasBox = activePanel.querySelector(".canvasBox"),
                UploadBox = tshirtUploadBox[index];

            UploadBox.classList.add("current");

            document.querySelectorAll('.tshirt-upload_sec .tshirt-upload_box.requred-error').forEach(item => {item.classList.remove('requred-error');});

            // show control panel
            tshirtPanelBox.classList.add("show");

            // create canvas
            let cc = document.createElement("canvas");
            cc.classList.add("canvas");
            cc.id = canvasId[index];
            CanvasBox.appendChild(cc);

            CanvasBox.width = cc.width = tshirtBox.clientWidth;
            CanvasBox.height = cc.height = tshirtBox.clientHeight;

            // create fabric canvas
            const canvas = new fabric.Canvas(canvasId[index]);
            var front_image;

            // outer line - box
            let posOuter = activePanel.getBoundingClientRect();
            let posInner = tshirtDrawBox.getBoundingClientRect();
            let pos = {
                width: posInner.width,
                height: posInner.height,
                top: posInner.y - posOuter.y,
                left: posInner.x - posOuter.x,
            };
            // console.log(pos);

            var shell = new fabric.Rect({
                width: pos.width,
                height: pos.height,
                top: pos.top,
                left: pos.left,
                fill: '',
                // stroke: 'blue',
                // strokeWidth: 1,
                scaleX: 1,
                scaleY: 1,
                // strokeDashArray: [8, 8],
                absolutePositioned: true,
                selectable: false,
                evented: false,
            });
            canvas.add(shell);

            const outerRect = {
                width: shell.width,
                height: shell.height,
                top: shell.top,
                left: shell.left,
                scale: 1,
            };

            // if (canvasId[index] == "arms") {
            //     outerRect.width = outerRect.width / 2;
            //     outerRect.height = outerRect.height / 2;
            //     outerRect.top = outerRect.top + outerRect.height / 2;
            //     outerRect.left = outerRect.left + outerRect.width / 2;
            // }

            // fabric image canvas
            canvas.selectionColor = 'rgba(0,0,255,0.05)';
            canvas.selectionBorderColor = 'rgba(0,0,255,0.5)';
            canvas.selectionLineWidth = 1;
            canvas.hoverCursor = 'pointer';
            // canvas.preserveObjectStacking = false;
            canvas.renderAll();

            canvas.on({
                'mouse:down': async (e) => {
                    if (e.target) {
                        e.target.hasControls = false;
                        e.target.opacity = 0.5;
                        canvas.renderAll();
                    }
                },
                'mouse:up': async (e) => {
                    if (e.target) {
                        e.target.hasControls = true;
                        e.target.opacity = 1;
                        canvas.renderAll();
                    }
                },
                'object:moved': async (e) => {
                    if (e.target) {
                        e.target.hasControls = false;
                        e.target.opacity = 0.5;
                        canvas.renderAll();
                    }
                },
                'object:modified': async (e) => {
                    if (e.target) {
                        e.target.hasControls = false;
                        e.target.opacity = 1;
                        canvas.renderAll();
                    }
                },
                'mouse:over': async (e) => {
                    if (e.target) {
                        e.target.hasControls = true;
                        e.target.borderColor = 'red';
                        canvas.renderAll();
                        tshirtDrawBox.classList.add("show");
                    }
                },
                'mouse:out': async (e) => {
                    if (e.target) {
                        e.target.borderColor = "transparent";
                        e.target.hasControls = false;
                        canvas.renderAll();
                        tshirtDrawBox.classList.remove("show");
                    }
                }
              // ,
              //   'event:scaled': async (e) => {
              //     console.log("Scaled")
              //   },
              //   'event:scaled': async (e) => {
              //     console.log("Scaled")
              //   },
              //   'event:scaled': async (e) => {
              //     console.log("Scaled")
              //   },
              //   'event:scaled': async (e) => {
              //     console.log("Scaled")
              //   },
              //   'event:scaled': async (e) => {
              //     console.log("Scaled")
              //   },
              //   'event:scaled': async (e) => {
              //     console.log("Scaled")
              //   },
              //   'event:scaled': async (e) => {
              //     console.log("Scaled")
              //   }              
            });

            // uploaded image
            setTimeout(() => {
                var clipPath = new fabric.Rect({ width: shell.width, height: shell.height, top: shell.top, left: shell.left, absolutePositioned: true });
                fabric.Image.fromURL(imgObj, function (img) {
                    front_image = img;
                    img.scaleToWidth(outerRect.width);
                    outerRect.scale = img.scaleX;
                    img.set({
                        clipPath: clipPath,
                        top: parseInt(outerRect.top + outerRect.height / 2, 10),
                        left: parseInt(outerRect.left + outerRect.width / 2, 10),
                        flipX: false,
                        flipY: false,
                        scaleX: outerRect.scale,
                        scaleY: outerRect.scale,
                        angle: 0,
                        originX: 'center',
                        originY: 'center',
                        borderColor: 'transparent',
                        borderDashArray: [2, 2],
                    });
                    img.hasControls = false;
                    canvas.setActiveObject(img);
                    canvas.add(img);
                    canvas.renderAll();
                }, { crossOrigin: 'anonymous' });
            }, 200);

            // back button - control panel
            tshirtPanelBox.querySelector("[data-back]").addEventListener("click", (p) => {
                tshirtPanelBox.querySelectorAll(".box_pop").forEach((m) => {
                    m.classList.remove("show")
                });
                tshirtPanelBox.querySelector(".main_grp").classList.remove("hide");
                p.target.classList.remove("show");
            });

            // crop button - control panel
            tshirtPanelBox.querySelector("[data-crop]").addEventListener("click", (p) => {
                tshirtPanelBox.querySelectorAll(".box_pop").forEach((m) => {
                    m.classList.remove("show")
                })
                tshirtPanelBox.querySelector(".data-crop").classList.add("show");
                tshirtPanelBox.querySelector(".main_grp").classList.add("hide");
                tshirtPanelBox.querySelector("[data-back]").classList.add("show");
            });
            tshirtPanelBox.querySelectorAll("input[type='range']").forEach((m) => {
                let inp = m.parentElement.querySelector("input[type='number']");
                m.value = m.getAttribute("max") / 2;
                inp.setAttribute("max", m.getAttribute("max"));
                inp.setAttribute("min", m.getAttribute("min"));
                m.setAttribute("data-default", m.value);
                inp.value = m.value;
                inp.addEventListener("change", (p) => {
                    let el = p.target;
                    let el_val = Number(el.value);
                    if (el_val > el.getAttribute("max")) {
                        el_val = el.getAttribute("max");
                    } else if (el_val < el.getAttribute("min")) {
                        el_val = el.getAttribute("min");
                    }
                    m.value = el_val;

                    //trigger range-slider event
                    m.dispatchEvent(new Event('input', { bubbles: true }));
                });

                m.addEventListener("input", (p) => {
                    let el = p.target;
                    let setNum = el.parentElement.querySelector("input[type='number']");
                    setNum.value = el.value;

                    //scale canvas image
                    if (el.getAttribute("data-scale") != null) {
                        front_image.scaleToWidth(outerRect.scale).setCoords();
                        front_image.scale((outerRect.scale * el.value) / (m.getAttribute("max") / 2)).setCoords();
                    }
                    // //rotare canvas image
                    if (el.getAttribute("data-rotate") != null) {
                        front_image.set("angle", parseFloat(el.value)).setCoords()
                    }
                    canvas.requestRenderAll();
                    scrollTopp();
                })
            })

            // position button - control panel
            tshirtPanelBox.querySelector("[data-position]").addEventListener("click", (p) => {
                tshirtPanelBox.querySelectorAll(".box_pop").forEach((m) => {
                    m.classList.remove("show")
                })
                tshirtPanelBox.querySelector(".data-position").classList.add("show");
                tshirtPanelBox.querySelector(".main_grp").classList.add("hide");
                tshirtPanelBox.querySelector("[data-back]").classList.add("show");
            });
            tshirtPanelBox.querySelectorAll("[data-align]").forEach((m) => {
                m.addEventListener("click", (p) => {
                    let el = p.target;
                    let fn = el.getAttribute("data-align");
                    if (fn != null) {
                        if (fn == "top") {
                            front_image.set({
                                top: parseInt(outerRect.top, 10),
                                originY: 'top',
                            }).setCoords()
                        }
                        if (fn == "bottom") {
                            front_image.set({
                                top: parseInt((outerRect.height + outerRect.top) - (front_image.height * front_image.scaleY), 10),
                                originY: 'top',
                            }).setCoords()
                        }
                        if (fn == "left") {
                            front_image.set({
                                left: parseInt(outerRect.left, 10),
                                originX: 'left',
                            }).setCoords()
                        }
                        if (fn == "right") {
                            front_image.set({
                                left: parseInt(outerRect.left + outerRect.width, 10),
                                originX: 'right',
                            }).setCoords()
                        }
                        if (fn == "center") {
                            front_image.set({
                                top: parseInt(outerRect.top + outerRect.height / 2, 10),
                                left: parseInt(outerRect.left + outerRect.width / 2, 10),
                                originX: 'center',
                                originY: 'center',
                            }).setCoords()
                        }
                        canvas.requestRenderAll();
                        scrollTopp();                    
                    }
                });
            });
            tshirtPanelBox.querySelectorAll("[data-flip]").forEach((m) => {
                m.addEventListener("click", (p) => {
                    let el = p.target;
                    let fn = el.getAttribute("data-flip");
                    if (fn != null) {
                        if (fn == "vertical") {
                            front_image.set("flipY", !front_image.flipY
                            ).setCoords();
                        }
                        if (fn == "horizontal") {
                            front_image.set("flipX", !front_image.flipX).setCoords()
                        }
                        canvas.requestRenderAll();
                        scrollTopp();                    
                    }
                });
            });

            ////// reset button - control panel
            tshirtPanelBox.querySelector("[data-reset]").addEventListener("click", () => {
                front_image.set({
                    top: parseInt(outerRect.top + outerRect.height / 2, 10),
                    left: parseInt(outerRect.left + outerRect.width / 2, 10),
                    flipX: false,
                    flipY: false,
                    originX: 'center',
                    originY: 'center',
                    angle: 0,
                });
                front_image.scaleToWidth(outerRect.width);
                front_image.scale(front_image.scaleX).setCoords();
                canvas.requestRenderAll();
                scrollTopp();           

                tshirtPanelBox.querySelectorAll("input[type='range']").forEach((m) => {
                    m.value = m.getAttribute("data-default");
                    let setNum = m.parentElement.querySelector("input[type='number']");
                    setNum.value = m.value;
                });

            });

            /////// clear canvas
            UploadBox.parentElement.querySelector(".image_remove").addEventListener("click", function (m) {
                canvas.remove(canvas.getActiveObject());
                CanvasBox.innerHTML = "";
                m.target.classList.remove("show");
                UploadBox.removeAttribute("disabled");
                UploadBox.classList.remove("disable");
                UploadBox.parentElement.classList.remove("active");
                tshirtPanelBox.classList.remove("show");
                UploadBox.value = '';
                UploadBox.parentElement.querySelector(".fileName").innerHTML = "Upload your own design";

                let all_upbtn = wrapper.querySelectorAll(".tshirt-upload_box_inner.active");
                all_upbtn.forEach((p) => {
                    if (!p.classList.contains("current") && all_upbtn.length > 0) {
                        all_upbtn[0].classList.add("current")
                    }
                })
                theme_status == "t-shirt-customizer" ? checkValue() : checkValue(parseInt(currentQuantity));
              
                // tshirtUploaders.forEach((yo)=> {
                //   const styleAttribute = yo.getAttribute('style')
                //   if (styleAttribute && styleAttribute.includes('display: none;')) {
                //     tshirtSave.style.display = "none";
                //   } else {
                //     if(yo.querySelector(".tshirt-upload_box_inner").classList.contains("active")){
                //       tshirtSave.style.display = "block";
                //     } else {
                //       tshirtSave.style.display = "none";
                //     }
                    
                //   }
                // });
                
            });
        }

        /////// upload image
        tshirtUploadBox.forEach((e, i) => {
            e.addEventListener("change", function (m) {
                const file = m.target.files[0];
                if (m.target.files && m.target.files[0]) {
                  if (file && file.type === "application/pdf") {
                    convertFileToBase64(e, file);
                    const reader = new FileReader();
                   
                    reader.onload = function(f) {
                        const pdfData = f.target.result;
    
                        // Load PDF.js and render the first page
                        const loadingTask = pdfjsLib.getDocument({ data: pdfData });
                        loadingTask.promise.then(pdf => {
                            // Get the first page
                            pdf.getPage(1).then(page => {
                                const canvas = document.getElementById('pdfPreview');
                                const context = canvas.getContext('2d');
                                const viewport = page.getViewport({ scale: 0.5 });
    
                                // Adjust canvas size to fit PDF page
                                canvas.width = viewport.width;
                                canvas.height = viewport.height;
    
                                // Render the PDF page into the canvas context
                                page.render({
                                    canvasContext: context,
                                    viewport: viewport
                                }).promise.then(() => {
                                 let getFileName = m.target.files[0].name;
                                  if (getFileName.length) {
                                      let id = e.getAttribute('data-id');
                                      let imgDataUrl = canvas.toDataURL();
                                      e.closest('.tshirt-upload_box').setAttribute('data-filetype', getFileName);
                                      canvasId.filter((cv) => {
                                          //     console.log(cv, id);
                                          if (cv === id) {
                                              frontBackFabricDraw(allFabricBox[i], imgDataUrl, i);
                                          }
                                          else {
                                              return 0;
                                          }
                                      });
      
                                      e.parentElement.querySelector(".fileName").innerHTML = getFileName;
      
                                      tshirtUploadBox.forEach((k, j) => {
                                          allFabricBox[j].classList.remove("active");
                                          thumbImages[j].classList.remove("actv");
                                          k.parentElement.classList.remove("current");
                                          if (k === e) {
                                              e.parentElement.classList.add("active");
                                              allFabricBox[j].classList.add("active");
                                              thumbImages[j].classList.add("actv");
                                              k.parentElement.querySelector(".image_remove").classList.add("show");
                                              k.setAttribute("disabled", true);
                                              k.classList.add("disable");
                                              theme_status == "t-shirt-customizer" ? checkValue() : checkValue(parseInt(currentQuantity));
                                              k.parentElement.classList.add("current");
                                          }
                                      });
                                  }
                                });
                            });
                        });
                    };
    
                    // Read PDF as an ArrayBuffer for PDF.js to process
                    reader.readAsArrayBuffer(file);
                  } 
                  else {                 
                    const reader = new FileReader();
                    reader.addEventListener("load", function (event) {
                        var imgObj = new Image();
                        imgObj.src = event.target.result;
                        imgObj.onload = function () {
                            let getFileName = m.target.files[0].name;
                            convertImageToBase64(e, imgObj.src,getFileName);
                            e.closest('.tshirt-upload_box').setAttribute('data-filetype', getFileName);
                            if (getFileName.length) {
                                let id = e.getAttribute('data-id');

                                canvasId.filter((cv) => {
                                    if (cv === id) {
                                        frontBackFabricDraw(allFabricBox[i], imgObj.src, i);
                                    }
                                    else {
                                        return 0;
                                    }
                                });

                                e.parentElement.querySelector(".fileName").innerHTML = getFileName;

                                tshirtUploadBox.forEach((k, j) => {
                                  console.log(allFabricBox[j], thumbImages[j]);
                                    allFabricBox[j].classList.remove("active");
                                    thumbImages[j].classList.remove("actv");
                                    k.parentElement.classList.remove("current");
                                    if (k === e) {
                                        e.parentElement.classList.add("active");
                                        allFabricBox[j].classList.add("active");
                                        thumbImages[j].classList.add("actv");
                                        k.parentElement.querySelector(".image_remove").classList.add("show");
                                        k.setAttribute("disabled", true);
                                        k.classList.add("disable");
                                        theme_status == "t-shirt-customizer" ? checkValue() : checkValue(parseInt(currentQuantity));
                                        k.parentElement.classList.add("current");
                                    }
                                  
                                });
                            }
                        }
                    }, false);
                    reader.readAsDataURL(m.target.files[0]);
                  }
                }


              
            });
        });

        tshirtUploadBoxSelect.forEach((e, i) => {
            e.addEventListener("click", function (m) {
                tshirtUploadBoxSelect.forEach((e, i) => {
                    e.parentElement.classList.remove("current");
                });
                m.target.parentElement.classList.add("current");
                allFabricBox.forEach((k, j) => {
                    k.querySelectorAll(".box_pop").forEach((p) => {
                        p.classList.remove("show");
                    });
                    if (i == j) {
                        // console.log(k);  // TO BE OPENED
                        k.classList.add("active");
                        k.querySelector('.panel').classList.add("show");
                    }
                    else {
                        k.classList.remove("active");
                        k.querySelector('.panel').classList.remove("show");
                    }
                });
                

                thumbImages.forEach((m, l) => {
                    if (i == l) {
                        m.classList.add("actv");
                    }
                    else {
                        m.classList.remove("actv");
                    }
                });                
            });
        });

        //// update t-shirt color
        // tshirtColorsBox.forEach((e) => {
        //     e.addEventListener("change", function (m) {
        //         tshirtBox.style.backgroundColor = m.target.getAttribute("data-color")
        //     });
        // });
      
        // .change();
        const ne = new Event("change");
        const element = tshirtColorsBox[0]
        element.dispatchEvent(ne);

        ////// finally save as image
 
        tshirtSave.addEventListener("click", function () {
          document.querySelector("body").classList.add("zz-index");
          if (theme_status == "t-shirt-customizer") {
            allFabricBox.forEach((e, i) => {
                tshirtBox.querySelector(".t-shirt-loader").classList.add("open");
                let _this = e;
                let thisTarget = e.querySelector(".tshirt-panel-wrap");
                e.classList.add("is-visible");
                // if (e.classList.contains("active")) {
                // console.log(e.querySelector(".drawingArea"));  // TO BE OPENED

                e.querySelector(".drawingArea").classList.add("not-visible");
                e.querySelector(".panel").classList.add("not-visible")
                // }
                setTimeout(() => {

                    domtoimage.toPng(thisTarget, {
                    }).then(() => {
                      domtoimage.toPng(thisTarget, {
                      }).then(() => {
                        domtoimage.toPng(thisTarget, {
                        }).then(imgDataUrl => {
                          var img = new Image();
                          img.src = imgDataUrl;
                          let gotImg = document.querySelector(".gotImage");
                          gotImg.appendChild(img); 
                        })
                        .then(() => {
                            _this.classList.remove("is-visible");
                            _this.querySelector(".drawingArea").classList.remove("not-visible");
                            _this.querySelector(".panel").classList.remove("not-visible");
                            tshirtBox.querySelector(".t-shirt-loader").classList.remove("open");
                            document.querySelector(".previewImgOverlay").style.display = "block";
                            document.querySelector(".previewImg").style.display = "block";
                        })
                        .catch(function (error) {
                            console.error('oops, something went wrong!', error);
                        });                        
                      });
                    });                  

            
                  
                    // domtoimage.toPng(thisTarget).then(function (dataUrl) {
                    //     // console.log(dataUrl); // TO BE OPENED
                    //     var img = new Image();
                    //     img.src = dataUrl;
                    //     document.querySelector(".gotImage").appendChild(img);
                    // })
                    // .then(() => {
                    //     _this.classList.remove("is-visible");
                    //     _this.querySelector(".drawingArea").classList.remove("not-visible");
                    //     _this.querySelector(".panel").classList.remove("not-visible");
                    //     tshirtBox.querySelector(".t-shirt-loader").classList.remove("open");
                    //     document.querySelector(".previewImgOverlay").style.display = "block";
                    //     document.querySelector(".previewImg").style.display = "block";
                    // })
                    // .catch(function (error) {
                    //     console.error('oops, something went wrong!', error);
                    // });

                }, 200);
            });
          }
          if (theme_status == "second-customizer") {
            tshirtBox.querySelector(".t-shirt-loader").classList.add("open");
            let _this = document.querySelector("#front-panel");
            let thisTarget = _this.querySelector(".tshirt-panel-wrap");
            _this.classList.add("is-visible");
            _this.querySelector(".drawingArea").classList.add("not-visible");
            _this.querySelector(".panel").classList.add("not-visible")
            // }
            setTimeout(() => {

                domtoimage.toPng(thisTarget, {
                }).then(() => {
                  domtoimage.toPng(thisTarget, {
                  }).then(() => {
                    domtoimage.toPng(thisTarget, {
                    }).then(imgDataUrl => {
                      var img = new Image();
                      img.src = imgDataUrl;
                      let gotImg = document.querySelector(".gotImage");
                      gotImg.appendChild(img); 
                    })
                    .then(() => {
                        _this.classList.remove("is-visible");
                        _this.querySelector(".drawingArea").classList.remove("not-visible");
                        _this.querySelector(".panel").classList.remove("not-visible");
                        tshirtBox.querySelector(".t-shirt-loader").classList.remove("open");
                        document.querySelector(".previewImgOverlay").style.display = "block";
                        document.querySelector(".previewImg").style.display = "block";
                    })
                    .catch(function (error) {
                        console.error('oops, something went wrong!', error);
                    });
                  });
                });

            }, 200);            
          }
        })


    }
});

function scrollTopp() {
  if (window.innerWidth > 1024) {
    setTimeout(function(){
      elemEnt.scrollIntoView({ behavior: 'smooth' });
    }, 500);
  }
}

async function convertFileToBase64(e, file) {
    document.querySelector('.custom-atc-btn-wrap button').disabled = true;
    document.querySelector('.custom-atc-btn-wrap button .cartTxt').innerHTML = 'Processing Image...';
    const reader = new FileReader();
    reader.onloadend = async function() {
        const base64String = reader.result;
        
        const imageuploadendpoint = `${APP_URL}/api/cloudinary`;
        const uploadImageReq = await fetch(imageuploadendpoint,{
            method: "POST",
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({"base64Image": base64String, "alt": 'tsirt logo',"fileName":"t-shirt-logo", "fileType": 'pdf'})
        });
        const uploadImageRes = await uploadImageReq.json();
        e.closest('.tshirt-upload_box').setAttribute('data-baseurl', uploadImageRes.message.url);
        // document.querySelector('.custom-atc-btn-wrap button').disabled = false;
        enableATC();
    };

    reader.onerror = function(error) {
        console.error('Error reading file: ', error);
        document.querySelector('.custom-atc-btn-wrap button').disabled = false;
        document.querySelector('.custom-atc-btn-wrap button .cartTxt').innerHTML = 'ADD TO CART';
    };

    reader.readAsDataURL(file);
}

async function convertImageToBase64(e, base64String, filename){
  document.querySelector('.custom-atc-btn-wrap button').disabled = true;
  document.querySelector('.custom-atc-btn-wrap button .cartTxt').innerHTML = 'Processing Image...';
  const fileformate = filename.split('.').pop();
  const imageuploadendpoint = `${APP_URL}/api/cloudinary`;
    const uploadImageReq = await fetch(imageuploadendpoint,{
        method: "POST",
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({"base64Image": base64String, "alt": 'uploaded-logo',"fileName":"t-shirt-logo", "fileType": fileformate})
    });
    const uploadImageRes = await uploadImageReq.json();
    // console.log('uploadImageRes ',uploadImageRes);
    e.closest('.tshirt-upload_box').setAttribute('data-baseurl', uploadImageRes.message.url);
    // document.querySelector('.custom-atc-btn-wrap button').disabled = false;
    enableATC();
}

function enableATC(){
  let disabledATC = false;
  document.querySelectorAll('.tshirt-upload_sec .tshirt-image .tshirt-upload_box_inner.active').forEach(item => {
    const timage = item.closest('.tshirt-image');
    const baseurl = timage.getAttribute('data-baseurl');
      console.log('baseurl ',baseurl);
     if(timage.style.display != 'none' && baseurl == null){
       disabledATC = true;
     } 
  });
  if(disabledATC == false){
    document.querySelector('.custom-atc-btn-wrap button').disabled = false;
    document.querySelector('.custom-atc-btn-wrap button .cartTxt').innerHTML = 'ADD TO CART';
  }
}

  var colorVal;
  var sizeVal;
  var varID;
  let thisArr = [];
  let quantityVals = [];
  let basePrice = [];
  let currentArray = [];
  let currentId;

  checkValue();

  $(".colorOptions").change(function () {
    let frontImage;
    let backImage;
    
    $(this).parent().addClass("actv");
    $(this).parent().siblings().removeClass("actv");
    $(".selectedClr").text($(this).val());
    thisArr.length = 0;
    currentArray.length = 0;
    colorVal = $(this).val();
    
    $(this)
      .parents(".pro_cust_wrap")
      .find(".variantLoop")
      .find(".product-form__variants option")
      .each(function () {
        let thisValue = $(this).attr("data-first");
        if (thisValue == colorVal) {
          
          let $this = $(this);
          currentId = $(this).val();

          currentArray.push($(this).val());

          if(theme_status == "t-shirt-customizer") {
            thisArr.push({
              name: $($this).attr("data-second"),
              id: $(this).val(),
              title: $(this).data('title'),
              soldout: $($this).attr("data-quantity") == "0" ? true : false,
              quantity: $($this).attr("policy") == "continue" ? 1 : $($this).attr("data-quantity")
            });
          } else if (theme_status == "second-customizer") {
            thisArr.push({
              name: $(this).data('title'),
              id: $(this).val(),
              title: $(this).data('title'),
              soldout: $($this).attr("data-quantity") == "0" ? true : false,
              quantity: $($this).attr("policy") == "continue" ? 1 : $($this).attr("data-quantity"),
              price: $(this).attr('price')
            });            
          }

          
        }
      });
      
      let matchedVariant = basicVariants.find(variant => currentArray.includes(variant.id.toString()));

      $(matchedVariant.images).each(function(){
        if(this.type == "front"){
          frontImage = this.src;
        }
        if(this.type == "back"){
          backImage = this.src;
        }
      });
  
      $("#front-panel").find(".tshirt-img").attr("src", frontImage);
      $("#backside-panel").find(".tshirt-img").attr("src", backImage);
  
      $(".tshirt-thumb-wrap").find(".front-tshirt-img").attr("src", frontImage);
      $(".tshirt-thumb-wrap").find(".back-tshirt-img").attr("src", backImage);    
  
      $(".tshirt-thumb-wrap").css({"display": "flex"});

      if(theme_status == "t-shirt-customizer") {
        $(this)
          .parents(".pro_cust_wrap")
          .find(".sizeVals .valsInner")
          .each(function (index, element) {
            $(this).find(".sizeQuant").val(0);
            quantityVals.length = 0;
    
            let currentCurr = $(".total_price").attr('data-curr-format');
            let baseFinalPrice = $(".total_price").attr('base-price');
            let formattedPrice = (baseFinalPrice / 100).toFixed(2);  
            $(".total_price").text(currentCurr + formattedPrice);
            
            var arrayItem = thisArr[index];
            // console.log('arrayItem.id ',arrayItem.title); // TO BE OPENED
            $(element).find(".sizeOptions").attr("data-var-id", arrayItem.id);
            $(element).find(".sizeOptions").attr("data-var-title", arrayItem.title);
            if (arrayItem.soldout) {
              if(!$(element).hasClass("soldOut")){
                $(element).addClass("soldOut");
              }
              // $(element).find(".inv_quantt").html("<span class='red'>Out of stock</span>")
            } 
            else {
              $(element).removeClass("soldOut");
              // if(arrayItem.quantity > 10){
              //   $(element).find(".inv_quantt").html("<span class='green'>10+ in stock</span>")
              // } else if(arrayItem.quantity < 10 && arrayItem.quantity > 0) {
              //   $(element).find(".inv_quantt").html("<span class='yellow'>10- in stock</span>")
              // }
    
            }
          });
        $(".sizeVals .valsInner").first().find(".sizeQuant").val(1);
      }

      checkValue();
  });

  // if (theme_status == "t-shirt-customizer") { 
    $(".frnt").click(function(){
      $(this).addClass("actv");
      $(".bck").removeClass("actv");
      $("#front-panel").addClass("active");
      $("#backside-panel").removeClass("active");
    });
    $(".bck").click(function(){
      $(this).addClass("actv");
      $(".frnt").removeClass("actv");    
      $("#front-panel").removeClass("active");
      $("#backside-panel").addClass("active");
    });
  // }
  // if (theme_status == "second-customizer") { 

  // }

    /* on add to cart button click */


  document.querySelector('.custom-atc-btn-wrap button.button')?.addEventListener('click', async function(event) {
      event.preventDefault();
      const print_locations = document.querySelectorAll('.print_locationWrap li.print_locations');
      const active_print_location = document.querySelectorAll('.print_locationWrap li.print_locations.actv');
      
      if (print_locations.length > 0 && active_print_location.length === 0) {
          document.querySelector('.print_locationWrap .error-wrap').innerHTML = '<p>Please select a print location and upload print logo</p>';
         return true;
      }
  
    const selectedPrintlocation = document.querySelectorAll('.print_locations_list li.print_locations.actv.show_item')[0].dataset.title;
    let hasRequredError = false;
    document.querySelectorAll('.tshirt-upload_sec .tshirt-upload_box').forEach(item => {
        const computedStyle = window.getComputedStyle(item);
        const isVisible = computedStyle.display !== 'none';
        const hasClassActive = item.querySelector('.tshirt-upload_box_inner').classList.contains('active');
        if(isVisible && !hasClassActive){
         item.classList.add('requred-error');
          hasRequredError = true;
          return true;
        }
    });
    if(hasRequredError && selectedPrintlocation != 'No Print'){return true;}
     
    const hasItemWithQuanity = quantityVals.filter(item => item.quantity > 0);
    const dataQty = parseInt(document.querySelector('tr.biw-body .min-quantity').dataset.qty);
    const totalQuantity = hasItemWithQuanity.reduce((sum, item) => sum + parseInt(item.quantity, 10), 0);
    if(hasItemWithQuanity.length == 0){
      document.querySelector('.quantity-error-message').innerHTML = '<p>Please make sure there is at least one quantity.</p>';
      document.querySelector('.quantity-error-message').classList.add('show');
      document.querySelector('.quantity-error-message').scrollIntoView({ behavior: 'smooth', block: 'center' });
      return true;
    }else if(dataQty > totalQuantity){
      document.querySelector('.quantity-error-message').innerHTML = `<p>Please quantity must meet the minimum requirement of ${dataQty}.</p>`;
      document.querySelector('.quantity-error-message').classList.add('show');
      document.querySelector('.quantity-error-message').scrollIntoView({ behavior: 'smooth', block: 'center' });
      return true;
    }
  
    this.classList.add('loading');
    document.querySelector('.custom-atc-btn-wrap button.button').setAttribute('disabled', true);
    
  
    const pl_title = quantityVals[0].pl_title;
    const pl_price = quantityVals[0].pl_price;
    console.log('quantityVals ',quantityVals);
    
     
    if(pl_price > 0 && pl_title != ''){
      const print_location_id = print_location_product.variants.filter(variant => variant.title == pl_title)[0].id;
      printLocationWithoutProductCraete(print_location_id);
      
    }else if(pl_price == 0 && pl_title != ''){
      printLocationWithoutProductCraete(null);
    }else{
      
      const items = quantityVals.filter(item => item.quantity > 0).map(({ id, quantity }) => ({id,quantity,properties: { "Print Location": pl_title }}));
      customAddToCart(items);
      
    }
  });

  async function uploadLogoAssets() {
      const logoArr = [];
      const items = document.querySelectorAll('.tshirt-upload_sec_wrap .tshirt-upload_box');
      
      for (const item of items) {
          const faceName = item.dataset.face;
          const baseurl = item.dataset.baseurl;
          const filename = item.dataset.filetype;
          logoArr.push({ 'side': faceName, 'url': baseurl });
  
          // if (item.style.display !== 'none' && baseurl) {
          //    if(filename.indexOf('.pdf') > -1){
               
          //       logoArr.push({ 'side': faceName, 'url': baseurl });
               
          //    }else{
          //       const imageuploadendpoint = `${location.origin}/apps/proxy`;
          //       const uploadImageReq = await fetch(imageuploadendpoint, {
          //           method: "POST",
          //           headers: { 'Content-Type': 'application/json' },
          //           body: JSON.stringify({ "type": "upload_file_asset", "filename": faceName, "base64url": baseurl })
          //       });
    
          //       const uploadImageRes = await uploadImageReq.json();
          //       const imageUrl = uploadImageRes.data.asset.public_url;
          //       logoArr.push({ 'side': faceName, 'url': imageUrl });
          //    }
          // }
      }
  
      return logoArr;
  }

  async function printLocationWithoutProductCraete(print_location_vid){
    const base64image = await createfinalImages();

    /* upload image printed image to cloudinary */
    const uploadimagekitendpoint = `${APP_URL}/api/cloudinary`;
    const uploadimagekitReq = await fetch(uploadimagekitendpoint,{
        method: "POST",
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({"base64Image": base64image.base64Image, "alt": 't-shirt customized design',"fileName":"t-shirt-customized-design","fileType": 'jpg'})
    });
    const uploadimagekitRes = await uploadimagekitReq.json();
    const imageUrl = uploadimagekitRes.message.url;

    const logodata = await uploadLogoAssets();
    
    const updatednewitems = [];
    const newitems = quantityVals.filter(item => item.quantity > 0).map(({ id, quantity, pl_title }) => ({id,quantity,properties: { "Print Location": pl_title, "_main_product_handle": product.handle, "_final_design": imageUrl, "_uploaded_file_front": logodata[0].url,"_uploaded_file_back": logodata[1].url ? logodata[1].url : "" }}));
    newitems.forEach(item => {
      
        updatednewitems.push(item);
      
        if(parseInt(quantityVals[0].pl_price) > 0){
          updatednewitems.push({
              id: print_location_vid,
              quantity: item.quantity,
              properties: {"_main_vid": item.id, "_final_design": imageUrl}
          });
        }
      
    });
    
    customAddToCart(updatednewitems);
    
  }
  
  async function createProduct(items){
    const base64images = await createImage();
    const base64image = base64images.filter(item => item.alt == 'front')[0];
    // console.log('base64image ',base64image); // TO BE OPENED
    const imageuploadendpoint = `${APP_URL}/api/cloudinary`;
    const uploadImageReq = await fetch(imageuploadendpoint,{
        method: "POST",
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(base64image)
    });
    const uploadImageRes = await uploadImageReq.json();
    // console.log('uploadImageRes ',uploadImageRes); // TO BE OPENED
    
    const tags = product.tags.length ? product.tags: [];
    tags.push('personalized');
    const appfiltervariant = basicVariants.filter(item => item.id == items[0].id);
    let images = appfiltervariant[0].images.filter(item => item.src != '').map(item => ({"src": item.src, "alt": item.type}));
    if(images.length == 0 && product.images.length > 0){images.push({"src": `https:${product.images[0]}`, "alt": ''});}
    
    const pricevaries = parseFloat(document.querySelector('.print_locations_list').dataset.pricevaries);
  
     const variants = items.map(item => {
        const [option1, option2] = item.title.split(' / ');
        const price = ((parseInt(item.price) + parseInt(item.pl_price)) / 100) / pricevaries;
        return {
          option1: option1,           // Color
          option2: option2,            // Size
          option3: item.pl_title,    // Print Location
          price: price,
          inventory_management: "shopify",
          inventory_policy: "continue",
          inventory_quantity: 100
        };
      });
      
      // Extracting options
      const option1 = [...new Set(items.map(item => item.title.split(' / ')[0]))]; // Unique Colors
      const option2 = [...new Set(items.map(item => item.title.split(' / ')[1]))];  // Unique Sizes
      const printLocations = [...new Set(items.map(item => item.pl_title))];      // Unique Print Locations
      
      const options = [
        {
          name: product.options[0],
          values: option1
        },
        {
          name: product.options[1],
          values: option2
        },
        {
          name: "Print Location",
          values: printLocations
        }
      ];
  
     const productData = {
        product: {
          title: product.title,
          body_html: product.content,
          vendor: product.vendor,
          product_type: product.type,
          tags: product.tags,
          variants: variants,
          options: options,
          images: images
        }
      };
  
      const endpoint = `https://${location.host}/apps/proxy`;
      const createProductReq = await fetch(endpoint,{
          method: "POST",
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({"type": "create_product", "product": productData.product, "images": images})
      });
      const createProductRes = await createProductReq.json();
      const newproductdata = createProductRes.data.product;
      const newitems = quantityVals.filter(item => item.quantity > 0).map((item, index) => ({"id": newproductdata.variants[index].id,"quantity": item.quantity,properties: { "Print Location": item.pl_title, "_main_product_handle": product.handle, "_final_design": uploadImageRes.message.secure_url }}));
      customAddToCart(newitems);
  }
  
  async function createImage() {
      const allFabricBox = document.querySelectorAll("#t-modification .tshirt-panel");
      const tshirtBox = document.querySelector("#t-modification .tshirt-div");
      const images = [];
      const imagePromises = [];
  
      // Show loader
      tshirtBox.querySelector(".t-shirt-loader").classList.add("open");
  
      for (let i = 0; i < allFabricBox.length; i++) {
          let e = allFabricBox[i];
          const faceType = e.getAttribute('id') == 'front-panel' ? 'front' : 'back'; 
          let thisTarget = e.querySelector(".tshirt-panel-wrap");
          e.classList.add("is-visible");
          e.querySelector(".drawingArea").classList.add("not-visible");
          e.querySelector(".panel").classList.add("not-visible");
  
          const imagePromise = new Promise((resolve, reject) => {
              setTimeout(() => {

                  domtoimage.toPng(thisTarget, {
                  }).then(() => {
                    domtoimage.toPng(thisTarget, {
                    }).then(() => {
                      domtoimage.toPng(thisTarget, {
                      }).then(dataUrl => {
                          // Convert Base64 to JPEG format
                          const base64Image = dataUrl.replace("data:image/png;base64,",""); // Replace with your actual base64 string
                          images.push({ "base64Image": dataUrl, "filename": `image${i + 1}.jpg`, "alt": faceType, "position": i+1 });
                           e.querySelector(".drawingArea").classList.remove("not-visible");
                           e.querySelector(".panel").classList.remove("not-visible");
                           e.classList.remove("is-visible");
                          resolve();
                      })
                      .catch(function (error) {
                          console.error('oops, something went wrong!', error);
                      });                        
                    });
                  });                
                
                  // domtoimage.toPng(thisTarget)
                  //     .then((dataUrl) => {
                  //         // Convert Base64 to JPEG format
                  //         const base64Image = dataUrl.replace("data:image/png;base64,",""); // Replace with your actual base64 string
                  //         images.push({ "base64Image": dataUrl, "filename": `image${i + 1}.jpg`, "alt": faceType, "position": i+1 });
                  //          e.querySelector(".drawingArea").classList.remove("not-visible");
                  //          e.querySelector(".panel").classList.remove("not-visible");
                  //          e.classList.remove("is-visible");
                  //         resolve();
                  //     })
                  //     .catch((error) => {
                  //         console.error('oops, something went wrong!', error);
                  //         reject(error);
                  //     });
                
              }, 10);
          });
  
          imagePromises.push(imagePromise);
      }
  
      try {
          await Promise.all(imagePromises);
          // console.log('All images processed:', images);  // TO BE OPENED
          return images; // Return the images array
      } catch (error) {
          console.error('Error processing images:', error);
      } finally {
          // Hide loader after processing is done
          tshirtBox.querySelector(".t-shirt-loader").classList.remove("open");
      }
  }
  
  async function createfinalImages() {
      const allFabricBox = document.querySelectorAll("#t-modification .tshirt-panel.fd_print");
      const tshirtBox = document.querySelector("#t-modification .tshirt-div");
      const images = [];
      const imagePromises = [];
  
      // Show loader
      tshirtBox.querySelector(".t-shirt-loader").classList.add("open");
    
      for (let i = 0; i < allFabricBox.length; i++) {
          let e = allFabricBox[i];
          const faceType = e.getAttribute('id') === 'front-panel' ? 'front' : 'back'; 
          let thisTarget = e.querySelector(".tshirt-panel-wrap");
          e.classList.add("is-visible");
          e.querySelector(".drawingArea").classList.add("not-visible");
          e.querySelector(".panel").classList.add("not-visible");
  
          const imagePromise = new Promise((resolve, reject) => {
              setTimeout(() => {
                  domtoimage.toPng(thisTarget, {
                  }).then(() => {
                    domtoimage.toPng(thisTarget, {
                    }).then(() => {
                      domtoimage.toPng(thisTarget, {
                      }).then(dataUrl => {
                          // Convert Base64 to JPEG format
                          const base64Image = dataUrl.replace("data:image/png;base64,", "");
                          images.push({ "base64Image": base64Image, "filename": `image${i + 1}.jpg`, "alt": faceType, "position": i+1 });
                          e.querySelector(".drawingArea").classList.remove("not-visible");
                          e.querySelector(".panel").classList.remove("not-visible");
                          e.classList.remove("is-visible");
                          resolve();
                      })
                      .catch(function (error) {
                          console.error('oops, something went wrong!', error);
                      });                        
                    });
                  });                  
                 
              }, 400);
          });
  
          imagePromises.push(imagePromise);
      }
  
      try {
          await Promise.all(imagePromises);
          
          // Combine both images vertically in a single image with white background
          if(allFabricBox.length == 2){
            if (images.length === allFabricBox.length) {
                const combinedImage = await combineImages(images[0].base64Image, images[1].base64Image);
                return ({"base64Image": combinedImage, "alt": "final"});
            }
          }else if(allFabricBox.length == 1){
            if (images.length === allFabricBox.length) {
                const combinedImage = 'data:image/png;base64,' + images[0].base64Image;
                return ({"base64Image": combinedImage, "alt": "final"});
            }
          }
          
      } catch (error) {
          console.error('Error processing images:', error);
      } finally {
          tshirtBox.querySelector(".t-shirt-loader").classList.remove("open");
      }
  }
  
  // Helper function to combine images vertically
  async function combineImages(frontBase64, backBase64) {
    return new Promise((resolve, reject) => {
        const frontImg = new Image();
        const backImg = new Image();
        
        frontImg.src = 'data:image/png;base64,' + frontBase64;
        backImg.src = 'data:image/png;base64,' + backBase64;

        frontImg.onload = () => {
            backImg.onload = () => {
                // Set canvas dimensions to fit both images side by side
                const canvas = document.createElement("canvas");
                canvas.width = frontImg.width + backImg.width; // total width for side-by-side
                canvas.height = Math.max(frontImg.height, backImg.height); // height of the taller image
                const ctx = canvas.getContext("2d");

                // Set canvas background to white
                ctx.fillStyle = "#FFFFFF";
                ctx.fillRect(0, 0, canvas.width, canvas.height);

                // Draw front image on the left
                ctx.drawImage(frontImg, 0, 0);

                // Draw back image on the right of the front image
                ctx.drawImage(backImg, frontImg.width, 0);

                // Convert canvas to base64 image
                const combinedBase64 = canvas.toDataURL("image/jpeg");
                resolve(combinedBase64);
            };
            backImg.onerror = reject;
        };
        frontImg.onerror = reject;
    });
}

  async function customAddToCart(items) {
    // Optional: Sections to update after item is added to cart
    let sectionsToBundle = []; // You can add section IDs if needed (e.g., ["cart-icon-bubble", "cart-drawer"])
  
    // Notify theme that grouped sections are about to be updated
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', {
        bubbles: true,
        detail: { sections: sectionsToBundle },
      })
    );
  
    const formData = {
      items, // Array of items: [{ id: variantId, quantity: 1 }]
      sections: sectionsToBundle,
    };
  
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });
  
      const responseJson = await response.json();
  
      if (!response.ok) {
        throw new Error(responseJson.description || 'Failed to add items to the cart');
      }
  
      // Fetch updated cart data
      const cartJson = await (
        await fetch(FoxTheme.routes.cart_url, {
          ...FoxTheme.utils.fetchConfig(),
        })
      ).json();
  
      // Include sections if necessary
      cartJson.sections = responseJson.sections;
  
      // Publish cart update event (if using a pub/sub system)
      FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
        cart: cartJson,
      });
  
      // Trigger product added event
      document.dispatchEvent(
        new CustomEvent('product-ajax:added', {
          detail: { product: responseJson },
        })
      );
  
      document.querySelector('.cart-drawer-button').click();
  
    } catch (error) {
      console.error('Error:', error);
  
      // Trigger error event
      document.dispatchEvent(
        new CustomEvent('cart:error', {
          bubbles: true,
          detail: { error: error.message },
        })
      );
  
      // Optionally refresh cart UI
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } finally {
      // Re-enable button
      const customAddToCartButton = document.querySelector('.custom-atc-btn-wrap button.button');
      if (customAddToCartButton) {
        customAddToCartButton.classList.remove('loading');
        customAddToCartButton.removeAttribute('disabled');
      }
    }
  }

  function sumArray(arr) {
      var total = 0;
      arr.forEach(function(element){
          total += element;
      })
      return total;
  }

  function checkValue(el) {
    quantityVals.length = 0;

    let pl_price = 0;
    let pl_title = "";
    const print_locations = document.querySelectorAll('.print_locationWrap li.print_locations');
    const active_print_location = document.querySelectorAll('.print_locationWrap li.print_locations.actv');
    const pl_logo_uploaded = document.querySelectorAll('.tshirt-upload_sec .tshirt-upload_box .tshirt-upload_box_inner.active');
      
    if (active_print_location.length > 0) {
        pl_price = active_print_location[0].dataset.price;
        pl_title = active_print_location[0].dataset.title;
    }else if(active_print_location.length > 0){
      pl_title = active_print_location[0].dataset.title;
    }

    if(theme_status == "t-shirt-customizer") {
      $(".sizeVals .valsInner").each(function(){
        let thisId = $(this).find(".sizeOptions").attr("data-var-id");
        let thisTitle = $(this).find(".sizeOptions").attr("data-var-title");
        let thisQuant = $(this).find(".sizeQuant").val();
        let thisPrice = $(this).find(".sizeOptions").attr("data-price");
        quantityVals.push({id: thisId,title: thisTitle,quantity: thisQuant,pl_title:pl_title,pl_price:pl_price,price: thisPrice});
      });
    } 
    else if (theme_status == "second-customizer") {
        console.log('thisArr asasas',thisArr);
        const print_type = document.querySelector('.print_locations_list li.print_locations.actv.show_item')?.dataset.title;
        const selectedArr = thisArr.filter(item => item.name.indexOf(print_type) > -1);
        console.log('selectedArr asasas',selectedArr);
        if(selectedArr.length > 0){
          let thisId = selectedArr[0].id;
          let thisTitle = selectedArr[0].name;
          let thisQuant = document.querySelector('input#quantttInput').value;
          let thisPrice = selectedArr[0].price;
          quantityVals.push({id: thisId,title: thisTitle,quantity: thisQuant,pl_title:pl_title,pl_price:pl_price,price: thisPrice});
        }else{
          let thisId = thisArr.length > 0 ? thisArr[0].id : '';
          let thisTitle = thisArr.map(item => item.name);
          let thisQuant = document.querySelector('input#quantttInput').value;
          let thisPrice = thisArr.map(item => item.price);
          quantityVals.push({id: thisId,title: thisTitle,quantity: thisQuant,pl_title:pl_title,pl_price:pl_price,price: thisPrice});
        }
        console.log('quantityVals ',quantityVals);
    }
    
    const onlyselectQtyVals = quantityVals.filter(item => item.quantity > 0);
    const totals = onlyselectQtyVals.reduce((acc, item) => {
        const quantity = parseInt(item.quantity);
          acc.quantity += quantity;
          acc.totalPlPrice += parseFloat(item.pl_price) * quantity;
          acc.totalPrice += parseFloat(item.price) * quantity;
          return acc;          
      },
      { quantity: 0, totalPlPrice: 0, totalPrice: 0 }
    );
    
    const currentCurr = $(".total_price").attr('data-curr-format');
    let originalAmount, subtotalPrice, updatedPrice, imagePrice; 
    // 10+ Units = 15% Off, 20+ Units = 30% Off, 50+ Units = 35% Off.

    let discountTiers = JSON.parse(document.getElementById("discountTiers").textContent);
    
    if ($("#hasDiscount").val() == "true") {
      let updatedPrice, imagePrice, subtotalPrice, originalAmount;
      let discountApplied = false;  // Flag to track if a discount was applied

      if(discountTiers) {
        // Loop through discountTiers to find the appropriate discount tier
        for (let i = 0; i < discountTiers.length; i++) {
          const tier = discountTiers[i];
      
          // If quantity meets the minimum required for this discount tier
          if (totals.quantity >= tier.min_quantity && !discountApplied) {
            updatedPrice = totals.totalPrice - (totals.totalPrice * tier.discount);
            imagePrice = totals.totalPlPrice - (totals.totalPlPrice * tier.discount);
      
            subtotalPrice = ((imagePrice + updatedPrice) / 100).toFixed(2);
            originalAmount = ((totals.totalPlPrice + totals.totalPrice) / 100).toFixed(2);
      
            // Update the total price and image price data attributes and innerHTML
            const totalPriceElement = document.querySelector('.total_price');
            totalPriceElement.setAttribute('data-updated-price', updatedPrice);
            totalPriceElement.setAttribute('data-image-price', imagePrice);
            totalPriceElement.innerHTML = currentCurr + ' ' + subtotalPrice;
      
            // Show the original price and discount label
            document.querySelector(".comparePrice").innerHTML = currentCurr + ' ' + originalAmount;
            document.querySelector(".saleAmount").innerHTML = tier.label;
            document.querySelector(".comparePrice").style.display = "block";
            document.querySelector(".saleAmount").style.display = "inline-block";
      
            // Mark the discount as applied
            discountApplied = true;
            break;  // Exit the loop after applying the discount
          }
        }
      }
    
      // If no discount tier matched (e.g., quantity < 10), show the original price without discount
      if (!discountApplied) {
        updatedPrice = totals.totalPrice;
        imagePrice = totals.totalPlPrice;
        subtotalPrice = ((imagePrice + updatedPrice) / 100).toFixed(2);
    
        const totalPriceElement = document.querySelector('.total_price');
        totalPriceElement.setAttribute('data-updated-price', updatedPrice);
        totalPriceElement.setAttribute('data-image-price', imagePrice);
        totalPriceElement.innerHTML = currentCurr + ' ' + subtotalPrice;
    
        // Hide the compare and sale labels if no discount is applied
        document.querySelector(".comparePrice").style.display = "none";
        document.querySelector(".saleAmount").style.display = "none";
      }
    } 
    else {
      // If there is no discount available, just show the original price
      updatedPrice = totals.totalPrice;
      imagePrice = totals.totalPlPrice;
      subtotalPrice = ((imagePrice + updatedPrice) / 100).toFixed(2);
    
      const totalPriceElement = document.querySelector('.total_price');
      totalPriceElement.setAttribute('data-updated-price', updatedPrice);
      totalPriceElement.setAttribute('data-image-price', imagePrice);
      totalPriceElement.innerHTML = currentCurr + ' ' + subtotalPrice;
    
      // Hide the compare and sale labels if no discount is available
      document.querySelector(".comparePrice").style.display = "none";
      document.querySelector(".saleAmount").style.display = "none";
    }
  
  }

  function updatePrice() {
    
    basePrice.length = 0;
    $(quantityVals).each(function(index, value){
      if(value.quantity != 0) {
        let baseCalc = parseInt(value.price) * parseInt(value.quantity);
        basePrice.push(baseCalc);
      }
    });

    // console.log(basePrice);
    var sum = sumArray(basePrice);
    let formattedPrice;

    let currentCurr = $(".total_price").attr('data-curr-format');
    
    var attr = $(".total_price").attr("data-image-price");
    
    if (typeof attr !== 'undefined' && attr !== false) {
      let imgPrice = $(".total_price").attr("data-image-price");
      let withImgPrice = sum + parseInt(imgPrice);
      formattedPrice = (withImgPrice / 100).toFixed(2);
    } else {
      formattedPrice = (sum / 100).toFixed(2);
    }

    $(".total_price").attr("data-updated-price", sum);
    $(".total_price").text(currentCurr + formattedPrice);
  }

  function updatePriceWithUpload(price) {
    // console.log('price ',price); // TO BE OPENED
    let currentCurr = $(".total_price").attr('data-curr-format');
    let currentPrice = $(".total_price").attr('data-updated-price');
    let sum = parseInt(currentPrice) + parseInt(price);
    let formattedPrice = (sum / 100).toFixed(2);

    $(".total_price").text(currentCurr + formattedPrice);
    $(".total_price").attr("data-image-price", price);
    checkValue();
  }

  // function updatePriceWithUpload(price) {
  //   let currentCurr = $(".total_price").attr('data-curr-format');
  //   let currentPrice = $(".total_price").attr('data-updated-price');
  //   let sum = parseInt(currentPrice) + parseInt(price);
  //   let formattedPrice = (sum / 100).toFixed(2);

  //   $(".total_price").text(currentCurr + formattedPrice);
  //   $(".total_price").attr("data-image-price", price);
  // }

  function removePriceWithUpload(price) {
    checkValue();
    let currentCurr = $(".total_price").attr('data-curr-format');
    let currentPrice = $(".total_price").attr('data-updated-price'); 
    
    // let sum = parseInt(price) - parseInt(currentPrice);
    let formattedPrice = (currentPrice / 100).toFixed(2);

    $(".total_price").text(currentCurr + formattedPrice);
    $(".total_price").attr("data-image-price", "");
  }


  $(".sizeQuant").bind('keyup change', function (e) {
    // let quantity = parseInt($(this).val());
    checkValue();
    if (e.target.value == '') {
      e.target.value = 0
    }    
    document.querySelector('.quantity-error-message').innerHTML = '';
    document.querySelector('.quantity-error-message').classList.remove('show');
  });

  if (theme_status == "second-customizer") {  

  const $quantityInput = $("#quantttInput");
  const $rangeSlider = $("#quantttRangeSlider");
  const $minusBtn = $("#quantttMinusBtn");
  const $plusBtn = $("#quantttPlusBtn");

  // Update range slider when quantity changes
  $quantityInput.on("blur", function () {
    console.log(set_min_quant, set_max_quant);
    let value = parseInt($(this).val());
    if (isNaN(value) || value < set_min_quant) value = set_min_quant;
    // if (value > set_max_quant) value = set_max_quant;
    $(this).val(value);
    $rangeSlider.val(value);
    toggleButtons(value);
    checkValue(value);
    currentQuantity = value;
  });

  // Update quantity input when range slider changes
  $rangeSlider.on("input", function () {
    const value = parseInt($(this).val());
    $quantityInput.val(value);
    toggleButtons(value);
    checkValue(value); 
    currentQuantity = value;
  });

  // Decrease quantity
  $minusBtn.on("click", function () {
    let value = parseInt($quantityInput.val());
    if (value > set_min_quant) {
      value -= 1;
      $quantityInput.val(value);
      $rangeSlider.val(value);
      toggleButtons(value);
      checkValue(value);     
      currentQuantity = value;
      updateQtyProcess();
    }
  });

  // Increase quantity
  $plusBtn.on("click", function () {
    let value = parseInt($quantityInput.val());
      value += 1;
      console.log(value);    
      $quantityInput.val(value);
      $rangeSlider.val(value);
      toggleButtons(value);
      checkValue(value);     
      currentQuantity = value;
      updateQtyProcess();
  });

  document.querySelectorAll('.process-bar-wrapper .progress-tab').forEach(qtyButton => {
    if(!qtyButton.classList.contains('active')){
          qtyButton.addEventListener('click', function(){
              document.querySelector('.process-bar-wrapper .progress-tab.active').classList.remove('active');
              const value = parseInt(qtyButton.dataset.min);
              qtyButton.classList.add('active');
              $quantityInput.val(value);
              $rangeSlider.val(value);
              toggleButtons(value);
              checkValue(value);     
              currentQuantity = value;
          });
      }
    });


  // Enable/Disable buttons based on value
  function toggleButtons(value) {
    $minusBtn.prop("disabled", value <= set_min_quant);
    // $plusBtn.prop("disabled", value >= set_max_quant);
  }

  // Initialize buttons state
  toggleButtons($quantityInput.val());
  }

  $(".sizeQuant").each(function () {
      $(this).data("previousValue", $(this).val());
  });   

  $('.quant_inc').click(function() {
    let quantity = parseInt($(this).parent().find(".sizeQuant").val());
    $(this).parent().find(".sizeQuant").val(quantity + 1);
    checkValue();
    setTimeout(function(){
      updatePrice();
    },100);
  });

  $('.quant_dec').click(function() {
    let quantity = parseInt($(this).parent().find(".sizeQuant").val());
    if (quantity > 0) {
      $(this).parent().find(".sizeQuant").val(quantity - 1);
      checkValue();  
      setTimeout(function(){
        updatePrice();
      },100);
    }
  });

  const kebabCase = string => string
      .replace(/([a-z])([A-Z])/g, "$1-$2")
      .replace(/[\s_]+/g, '-')
      .toLowerCase();

  $(".allOptionWrap").click(function(){
    $(this).toggleClass("actv");
    $(this).find("ul").toggle();
  });
  
  $(".print_locations").click(function(){
    $(this).toggleClass("actv").siblings().removeClass("actv");
  
    const pl_error_element = document.querySelector('.print_locationWrap .error-wrap');
    if(pl_error_element){pl_error_element.innerHTML = ''};

    if($(this).hasClass('actv')){
      const title = $(this).find('.print_locations_label').attr('title');
      $(this).parents('.print_locationWrap').find('.selectedpl').text(': '+title);
    }else{
      $(this).parents('.print_locationWrap').find('.selectedpl').text('');
    }

    document.querySelectorAll('.tshirt-upload_sec .tshirt-upload_box').forEach(item => {item.classList.remove('requred-error');});    

    if($(this).hasClass("actv")){
      $(".image_remove").click();
      if($(this).attr("data-price") != "0" || $(this).attr("data-title") != "No Print"){
       $(this).parents(".pro_cust_inner").find(".image_upload_sec").show(); 
      } else {
       $(this).parents(".pro_cust_inner").find(".image_upload_sec").hide(); 
      }
      let currentPrice = $(".print_locations.actv").attr("data-price");
      // updatePriceWithUpload(currentPrice);            
    } else {
      $(".image_remove").click();
      $(this).parents(".pro_cust_inner").find(".image_upload_sec").hide();
      let currentPrice = $(".print_locations.actv").attr("data-price");    
      // removePriceWithUpload(currentPrice);            
    }

    if (theme_status == "t-shirt-customizer") {
      let currentText = $(this).find("span").find("h3").text().trim();
      let currentTextWithoutPrinted = $(this).find("span").find("h3").text().trim().replace('Print', '');
      let kCased = $(this).find("span").attr('k-cased');  
  
      let firstVal = $(this).find("span").attr('first-val');  
      let secondVal = $(this).find("span").attr('second-val');        
      if(currentText.includes("Chest") && currentText.includes("Back") || currentText.includes("Front") && currentText.includes("Back")){
        $(".tshirt-image").show();
        // $(".drawingArea").attr("data-position", kCased);
        $("#front-panel .drawingArea").attr("data-position", firstVal);
        $("#backside-panel .drawingArea").attr("data-position", secondVal);
        let splitted = currentTextWithoutPrinted.split("+");
  
        firstTxt = splitted[0];
        lastTxt = splitted[1].replace('Print', '');
        
        $(".tshirt-image:first-child").find("h2").text(firstTxt);
        $(".tshirt-image:last-child").find("h2").text(lastTxt);
      } 
      else if (currentText.includes("Chest") || currentText.includes("Front")){
        $(".tshirt-image:first-child").show();
        $(".tshirt-image:last-child").hide(); 
        $(".tshirt-image:first-child").find("h2").text(currentTextWithoutPrinted);
        $("#front-panel").find(".drawingArea").attr("data-position", kCased);
      } 
      else if (currentText.includes("Back")){
        $(".tshirt-image:first-child").hide();
        $(".tshirt-image:last-child").show(); 
        $(".tshirt-image:last-child").find("h2").text(currentTextWithoutPrinted);
        $("#backside-panel").find(".drawingArea").attr("data-position", kCased);
      }
    }
    else if (theme_status == "second-customizer") {  
      let actualTitle = $(this).attr('data-title');
      let kCased = $(this).find("span").attr('k-cased');
      $(".tshirt-image:first-child").show();
      $(".tshirt-image:last-child").hide(); 
      $(".tshirt-image:first-child").find("h2").text(actualTitle);
      $("#front-panel").find(".drawingArea").attr("data-position", kCased);
    }

    if($(this).hasClass('actv')){
       $('.baseLocation').find('.base_locations_label').remove();
       $('.print_locations').removeClass('show_item');
       $(this).addClass('show_item');
       $('.base_span').hide();
       var label_html = $(this).html();
       var label_html_new = '<span class="base_locations_label">'+label_html+'</span>';
       $('.baseLocation').append(label_html_new);
    }
    else {
      $('.baseLocation').find('.base_locations_label').remove();
      $('.print_locations').first().addClass('show_item');
      $('.base_span').show();
    }
 
    checkValue();
  });

  $(document).ready(function(){
    if($("#hasDiscount").val() != "true"){
      $(".discount_sec").hide();
    }
    setTimeout(function(){
      $(".colorVals .valsInner:first-child").find("input").click();
    }, 200);

    $(".sizeTrigger").click(function(){
      document.querySelector("body").classList.add("zz-index");
      $(".sizeOverlay").show();
      $(".sizePop").show();
    });

    $(".closeSizePop").click(function(){
      document.querySelector("body").classList.remove("zz-index");
      $(".sizeOverlay").hide();
      $(".sizePop").hide();
    });   

    $(".sizeOverlay").click(function(){
      document.querySelector("body").classList.remove("zz-index");
      $(this).hide();
      $(".sizePop").hide();
    });   

    $(".closePreviewImg").click(function(){
      document.querySelector("body").classList.remove("zz-index");
      $(".previewImgOverlay").hide();
      $(".previewImg").hide();
      $(".gotImage img").remove();
    });   

    $(".previewImgOverlay").click(function(){
      document.querySelector("body").classList.remove("zz-index");
      $(this).hide();
      $(".previewImg").hide();
      $(".gotImage img").remove();
    });

    if(theme_status == "second-customizer") {
      checkValue(min__quantity)   
    }

    // DO NOT UNCOMMENT ============================================================================
    // let discountTiers = JSON.parse(document.getElementById("discountTiers").textContent);
    // let steps = [];
    // for (let i = 0; i < discountTiers.length; i++) {
    //   let tier = discountTiers[i];
    //   steps.push(tier.min_quantity);
    // }
    // steps.reverse();

    // steps.forEach(step => {
    //     const positionPercentage = ((step - set_min_quant) / (set_max_quant - set_min_quant)) * 100;
    //     const marker = document.createElement("div");
    //     marker.className = "rangePointers";
    //     marker.style.left = `${positionPercentage}%`;
    //     // marker.textContent = step;
    //     $(".quantttRangeSelector").append(marker);
    // });   

    // const slider = $("#quantttRangeSlider");
    // const sliderMarkers = $(".quantttRangeSelector");
    // const sliderWidth = $rangeSlider[0].offsetWidth;

    // steps.forEach(step => {
    //     console.log(step)
    //     const positionPercentage = ((step - set_min_quant) / (set_max_quant - set_min_quant)) * 100;
    //     const marker = document.createElement("div");
    //     marker.className = "rangePointers";
    //     marker.style.left = `calc(${positionPercentage}% - ${(sliderWidth / (set_max_quant - set_min_quant))}px)`;
    //     $(".quantttRangeSelector").append(marker);
    // });    
    // DO NOT UNCOMMENT ============================================================================
    
  });


document.querySelectorAll('.needSampleBtn a.nasBtn').forEach(item => {
   item.addEventListener('click', function(e){
       e.preventDefault();
       document.querySelector('.sample-product-popup').classList.add('active');
   });
});
document.querySelectorAll('.spp_wrapper span.close-popup').forEach(item => {
   item.addEventListener('click', function(e){
       e.preventDefault();
       document.querySelector('.sample-product-popup').classList.remove('active');
   });
});

document.querySelectorAll('.spp_wrapper button.spp_btn').forEach(item => {
   item.addEventListener('click', function(e){
       e.preventDefault();
       const vid = this.dataset.vid;
       const title = this.dataset.mainTitle;
       const url = `https://${window.location.host}${this.dataset.mainUrl}`;
       this.classList.add('loading');
       this.disabled = true;
       customAddToCart([{"id": vid, "quantity": 1,properties: { "Title": title, "Link": url }}]);
       setTimeout(function(){
         item.classList.remove('loading');
         item.disabled = false;
       },1000);
   });
});

function updateQtyProcess(){
  document.querySelectorAll('.quantttSelectWrap input#quantttInput').forEach(input => {
   const qty = parseInt(input.value);
   document.querySelector('.process-bar-wrapper .progress-tab.active')?.classList.remove('active');
   document.querySelectorAll('.process-bar-wrapper .progress-tab').forEach(qtyprocess => {
       const minQty = parseInt(qtyprocess.dataset.min);
       const maxQty = qtyprocess.dataset.max == 'above' ? 10000 : parseInt(qtyprocess.dataset.max);
       if(qty >= minQty && qty <= maxQty){
           qtyprocess.classList.add('active');
       }
   });
  });
}

updateQtyProcess();

document.querySelectorAll('.quantttSelectWrap input#quantttInput').forEach(input => {
  input.addEventListener('keyup', function() {
    updateQtyProcess();
  });
  input.addEventListener('change', function() {
    console.log('sjasjsdsdhg');
    updateQtyProcess();
  });
});


